import { useState, useEffect } from 'react';
import { Grid, makeStyles, Typography, Link } from "@material-ui/core";
import UtilService from "../../../../../../../../helper/service";
import roles from '../../../../../../../../helper/roles';
import { useHistory } from 'react-router';

//import clsx from 'clsx';
//import { useDispatch, useSelector } from "react-redux";


interface IProps {
    immersionData: any;
  }


  const ImmersionScore = (props: IProps) => {
    const classes = useStyles();
    const history = useHistory();
    const { immersionData } = props;

    const [immScorecommentary, setImmScorecommentary] = useState("Analyzing...");


    useEffect(() => {
        if (immersionData?.immersion_index) {
          
            if (immersionData?.immersion_index >= 90 && immersionData?.immersion_index < 100) {
              setImmScorecommentary("This score is amazing! Anytime you have a score above 90, you can be certain that this content will create action and new behavior in the audience.");
            } else if (immersionData?.immersion_index >= 80 && immersionData?.immersion_index < 90) {
              setImmScorecommentary(`This score is really good! A score of ${immersionData?.immersion_index} is significantly higher than the industry benchmark for this type of content.`);
            } else if (immersionData?.immersion_index >= 70 && immersionData?.immersion_index < 80) {
              setImmScorecommentary(`This score is remarkable. A score of ${immersionData?.immersion_index} is over 20% higher than the norm. You should feel pretty good about this experience.`);
            } else if (immersionData?.immersion_index >= 60 && immersionData?.immersion_index < 70) {
              setImmScorecommentary(`This score above average. If you think of Immersion on a bell curve, you can be assured that this score of ${immersionData?.immersion_index} is going to work well in market, but you could make it even better.`);
            } else if (immersionData?.immersion_index >= 50 && immersionData?.immersion_index < 60) {
              setImmScorecommentary(`This score is just slightly above average. At ${immersionData?.immersion_index}, you have some room to make this experience better for the audience. Have a look at the action items we suggest above.`);
            } else if (immersionData?.immersion_index >= 40 && immersionData?.immersion_index < 50) {
              setImmScorecommentary(`This score is just slightly below average. Depending on the audience you are after, you might consider a few tweaks to improve the score. Double check that your call to action is in a high Immersion zone.`);
            } else if (immersionData?.immersion_index >= 30 && immersionData?.immersion_index < 40) {
              setImmScorecommentary(`Hmmm... I bet this experience could be better. Look at the red zones in the second-by-second view, can you adjust the content to make them shorter or increase the number of high Immersion moments?`);
            } else if (immersionData?.immersion_index >= 20 && immersionData?.immersion_index < 30) {
              setImmScorecommentary(`Ugh. The good news is that you have a lot of room for improvement. Are you sure you targeted the right audience for this content? What changes could you make to improve the experience?`);
            } else if (immersionData?.immersion_index >= 0 && immersionData?.immersion_index < 20) {
              setImmScorecommentary(`Ouch. Brains were not connecting to this experience at all. Are you sure you targeted the right audience for this content? What changes could you make to improve the experience?`);
            } 
        }
      }, [props]);
    

      const goToAnalyze = () => {
        
        const currentSessionCode = localStorage.getItem("session_code") ? localStorage.getItem("session_code") : "";
        const userData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";
        let url = `/creator/experience-manager/analyze/${currentSessionCode}`;
        if (!!userData) {
          if (UtilService.checkTrialAccess(userData, roles['trial']['experiences'])) {
            url = `/subscriber/creator/experience-manager/analyze/${currentSessionCode}`;
          }
        }
        history.push(url, { session_id: localStorage.getItem("session_id") ? localStorage.getItem("session_id") : "" });
      };



    //console.log(`i score immersiondata = ${JSON.stringify(immersionData)}`);


    return (

        <Grid item xs={4} style={{textAlign: 'center'}}>
            <Typography variant="h1" color={'primary'} className={classes.itemtitle}>{!!immersionData ? immersionData.immersion_index : "0"}<span className={classes.subtitle}>/100</span></Typography>
            <Typography variant="body1" className={classes.sectionTitle}>Immersion Score</Typography>
            <Typography variant="body1" className={classes.bodyText}>{immScorecommentary}</Typography>
            <Link className={classes.actionLink} onClick={goToAnalyze}>
                <Typography variant="body1" className={classes.foo}>See the Detail</Typography>
            </Link>
            
          </Grid>

    )


  }

  export default ImmersionScore;

  const useStyles = makeStyles(() => ({
    root: {
      paddingTop: 0,
      '@media (max-width: 600px)': {
        paddingTop: 0,
      },
    },
    actionLink: {
      cursor:'pointer',
      //color: '#6667ab',
    },
    itemtitle: {
        fontSize: 90,
        fontFamily: 'Spartan-bold',
        marginBottom: -30,
    },
    subtitle: {
        fontSize: 24,
        color: '#cccccc'
    },
    bodyText: {
        color: '#697683',
        fontFamily: 'roboto-light',
    },
    sectionTitle: {
      fontSize: 16,
      fontFamily: 'roboto-bold',
      color: '#697683'
    },
    typeTitle: {
      fontSize: 24,
      fontFamily: 'Spartan-bold',
      color: '#697683',
      textAlign: 'center',
    },
    titleSection: {
      maxWidth: 500,
      display: 'flex',
      alignItems: 'center'
    },
    numberTitle: {
      marginTop: 5,
      fontSize: 29,
      minWidth: 60,
      textAlign: 'center',
      fontFamily: 'Spartan-extrabold',
      padding: '0 15px',
      '@media screen and (max-width: 600px)': {
        fontSize: 30
      }
    },
    title: {
      minWidth: 146,
      marginTop: 5,
      fontSize: 20,
      fontFamily: 'Spartan-bold',
      letterSpacing: '2px',
      textTransform: 'uppercase',
      '@media screen and (min-width: 331px) and (max-width: 600px)': {
        fontSize: 20
      },
      '@media screen and (max-width: 330px)': {
        fontSize: 18
      }
    },
    titleIcon: {
      width: 42,
      height: 42,
      '@media screen and (min-width: 331px) and (max-width: 600px)': {
        width: 35,
        height: 35
      },
      '@media screen and (max-width: 330px)': {
        width: 30,
        height: 30
      }
    },
    cardSection: {
      borderRadius: 20,
      background: '#fff',
      boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)"
    },
    pdfCardSection: {
      borderRadius: 20,
      background: '#fff',
      border: '1px solid rgba(0, 0, 0, 0.1)',
    },
    foo:{}
  }));